import React, { useCallback } from 'react';
import MainMenuView from './main-menu-view';
import { MainMenuContainerProps } from '../types';

const MainMenuContainer = ({
  activeMenu,
  activeMenuRef,
  emitNavClick,
  menuNames,
  onCloseMenu,
  onSelectMenu,
}: MainMenuContainerProps) => {
  const handleMenuClick = useCallback((menu: string) => {
    emitNavClick({
      nav_item: menu,
    });
    onSelectMenu(menu === activeMenu ? undefined : menu);
  }, [activeMenu, emitNavClick, onSelectMenu]);

  const handleKeyDown = useCallback((e: React.KeyboardEvent, currentMenu: string) => {
    switch (e.key) {
      case 'ArrowDown': {
        e.preventDefault();
        // If menu is open, navigate to its first sub-menu item
        onSelectMenu(currentMenu);
        break;
      }
      case 'Enter':
      case ' ': {
        e.preventDefault();
        onSelectMenu(currentMenu === activeMenu ? undefined : currentMenu);
        break;
      }
      case 'Escape': {
        e.preventDefault();
        onCloseMenu();
        break;
      }
      default:
        break;
    }
  }, [activeMenu, onCloseMenu, onSelectMenu]);

  return (
    <MainMenuView
      activeMenu={activeMenu}
      activeMenuRef={activeMenuRef}
      handleKeyDown={handleKeyDown}
      menuNames={menuNames}
      onMenuClick={handleMenuClick}
    />
  );
};

export default MainMenuContainer;
